import { useState } from "react";
import { X } from "lucide-react";

// Speech-bubble shaped launcher: portrait inside, tail pointing to the screen edge.
export function BubbleButton({ size, side, open, onClick }) {
    const [hover, setHover] = useState(false);
    const right = side === "right";
    const radius = right ? "22px 22px 6px 22px" : "22px 22px 22px 6px";

    return (
        <div className="relative" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <span
                className={`absolute top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full px-3.5 py-2 text-xs font-medium pointer-events-none transition-[opacity,transform] duration-200 ${right ? "right-full mr-3" : "left-full ml-3"}`}
                style={{
                    background: "rgba(11,15,26,0.92)", color: "var(--gold-100)", border: "1px solid var(--border-dark)", backdropFilter: "blur(12px)",
                    opacity: hover && !open ? 1 : 0, transform: `translateY(-50%) translateX(${hover && !open ? 0 : right ? 6 : -6}px)`,
                }}
                data-testid="assistant-bubble-label"
            >
                Une question sur le cours ?
            </span>
            <button
                onClick={onClick}
                className="relative block cursor-grab active:cursor-grabbing transition-transform duration-200 hover:-translate-y-0.5"
                style={{
                    width: size, height: size, borderRadius: radius, padding: 3,
                    background: "linear-gradient(145deg, #E5C679, #9C7A42)",
                    boxShadow: "0 14px 34px rgba(11,15,26,0.42), 0 2px 6px rgba(11,15,26,0.25)",
                }}
                data-testid="assistant-bubble-btn"
                aria-label={open ? "Fermer l'assistant" : "Ouvrir l'assistant"}
                title="Assistant — glissez pour déplacer"
            >
                <span className="block w-full h-full overflow-hidden relative" style={{ borderRadius: radius, background: "#F4EEDF" }}>
                    <img src="/assets/assistant.webp" alt="" draggable={false} className="w-full h-full object-cover select-none" />
                    {open && (
                        <span className="absolute inset-0 flex items-center justify-center" style={{ background: "rgba(11,15,26,0.72)" }}>
                            <X className="w-6 h-6" style={{ color: "var(--gold-100)" }} />
                        </span>
                    )}
                </span>
                <span
                    className={`absolute -top-2 ${right ? "-left-2" : "-right-2"} flex items-center gap-[3px] rounded-full px-2 py-1.5`}
                    style={{ background: "#0B0F1A", border: "1px solid rgba(201,164,88,0.55)" }}
                    data-testid="assistant-bubble-typing"
                >
                    {[0, 1, 2].map((i) => (
                        <span key={i} className="w-1 h-1 rounded-full animate-bounce" style={{ background: "var(--gold-200)", animationDelay: `${i * 0.15}s`, animationDuration: "1.2s" }} />
                    ))}
                </span>
            </button>
        </div>
    );
}
